<lib-not-modal [width]="'min(560px, 96dvw)'">
  <div class="staff-order-edit-dialog">
    <div class="staff-order-edit-dialog__head">
      <h3 class="staff-order-edit-dialog__title">
        {{ 'admin.storageRequests.editOrderTitle' | translate }}
      </h3>
      <p class="staff-order-edit-dialog__subtitle">
        {{ formatOrderShortPublicId(order().id) }}
      </p>
    </div>

    <form class="staff-order-edit-dialog__form" [formGroup]="form">
      @if (showPickupAddress()) {
        <lib-not-input
          type="text"
          formControlName="pickup_address"
          [label]="'admin.storageRequests.pickupAddress' | translate"
          [hideErrorBlock]="true"
        />
      }

      @if (showDeliveryAddress()) {
        <lib-not-input
          type="text"
          formControlName="delivery_address"
          [label]="'admin.storageRequests.deliveryAddressLabel' | translate"
          [hideErrorBlock]="true"
        />
      }

      <label class="staff-order-edit-dialog__datetime">
        <span class="staff-order-edit-dialog__label">{{
          'admin.storageRequests.orderScheduledAt' | translate
        }}</span>
        <input
          class="staff-order-edit-dialog__datetime-input"
          type="datetime-local"
          formControlName="scheduled_at"
        />
      </label>

      @if (showItemsDescription()) {
        <lib-not-input
          type="textarea"
          formControlName="items_description"
          [label]="'admin.storageRequests.itemsDescription' | translate"
          [hideErrorBlock]="true"
        />
      }

      @if (showAccessDescription()) {
        <lib-not-input
          type="textarea"
          formControlName="access_description"
          [label]="'admin.storageRequests.accessDescriptionLabel' | translate"
          [hideErrorBlock]="true"
        />
      }

      @if (showWarehouseSelect()) {
        <label class="staff-order-edit-dialog__select-wrap">
          <span class="staff-order-edit-dialog__label">{{
            'admin.storageRequests.warehouseLabel' | translate
          }}</span>
          <select
            class="staff-order-edit-dialog__select"
            formControlName="warehouse_id"
            [disabled]="warehousesLoading()"
          >
            <option value="">
              {{ 'admin.storageRequests.editOrderWarehouseEmpty' | translate }}
            </option>
            @for (warehouse of warehouses(); track warehouse.id) {
              <option [value]="warehouse.id">{{ warehouse.name }}</option>
            }
          </select>
        </label>
      }

      @if (showReturnToWarehouse()) {
        <label class="staff-order-edit-dialog__checkbox">
          <input type="checkbox" formControlName="return_to_warehouse" />
          <span>{{
            'admin.storageRequests.returnToWarehouseLabel' | translate
          }}</span>
        </label>
      }

      <p class="staff-order-edit-dialog__warning">
        {{ 'admin.storageRequests.editOrderReasonWarning' | translate }}
      </p>

      <lib-not-input
        type="textarea"
        formControlName="reason"
        [label]="'admin.storageRequests.changeReasonLabel' | translate"
        [placeholder]="
          'admin.storageRequests.changeReasonPlaceholder' | translate
        "
        [hideErrorBlock]="true"
      />
    </form>

    <div class="staff-order-edit-dialog__actions">
      <lib-cabinet-button
        type="button"
        variant="secondary"
        secondaryTone="neutral"
        size="lg"
        [fullWidth]="true"
        [text]="'common.actions.cancel' | translate"
        [action]="{ type: 'action' }"
        [disabled]="saving()"
        (actionEvent)="close()"
      />

      <lib-cabinet-button
        type="button"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="'admin.storageRequests.editOrderSave' | translate"
        [action]="{ type: 'action' }"
        [disabled]="saving()"
        [isLoading]="saving()"
        (actionEvent)="save()"
      />
    </div>
  </div>
</lib-not-modal>
